<div class="table-data">
  <table #table class="table-container display" [id]="tableId"></table>
</div>
